import g from '#core/global';
import load from '#core/load';


const WIREFRAME_ATTR = 'data-wireframe';
const STORAGE_KEY = 'wireframe-mode';
const URL_PARAM = 'wireframe';
const SHORTCUT_KEY = 'KeyW';


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('wireframe')) return false;

		load.now(() => {
			activate_from_storage();
		});
		load.content(() => {
			bind_shortcut();
		});
	},

	/**
	 * Toggle wireframe mode
	 */
	toggle() {
		toggle_mode();
	},

};

export default module;
module.init();


/**
 * Apply wireframe attribute if URL param or session storage flag is set
 */
function activate_from_storage() {
	const params = new URLSearchParams(window.location.search);
	if (params.has(URL_PARAM) || sessionStorage.getItem(STORAGE_KEY)) {
		document.documentElement.setAttribute(WIREFRAME_ATTR, '');
	}
}


/**
 * Bind Alt+W keyboard shortcut to toggle wireframe mode
 */
function bind_shortcut() {
	document.addEventListener(g.key_down_e, (e) => {
		if (e.altKey && !e.ctrlKey && !e.metaKey && e.code === SHORTCUT_KEY) {
			e.preventDefault();
			module.toggle();
		}
	});
}


/**
 * Toggle the wireframe attribute on the document root and persist state
 */
function toggle_mode() {
	const $root = document.documentElement;
	const is_wireframe_active = $root.hasAttribute(WIREFRAME_ATTR);
	
	if (is_wireframe_active) {
		$root.removeAttribute(WIREFRAME_ATTR);
		sessionStorage.removeItem(STORAGE_KEY);
	} else {
		$root.setAttribute(WIREFRAME_ATTR, '');
		sessionStorage.setItem(STORAGE_KEY, '1');
	}
}
